import React, { type PropsWithChildren } from "react";
import Slider, { type Settings } from "react-slick";

import { SliderButton } from "@/components/Explore/Vaults/SliderButton";
import "./Slider.css";

const settings: Settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  slidesPerRow: 3,
  prevArrow: <SliderButton direction="prev" />,
  nextArrow: <SliderButton direction="next" />,
  responsive: [
    {
      breakpoint: 1279,
      settings: {
        rows: 2,
        slidesPerRow: 2,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        rows: 1,
        slidesPerRow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        rows: 1,
        // centerMode: true,
        // centerPadding: "16px",
        slidesPerRow: 1,
      },
    },
  ],
};

interface HomepageVaultsSliderProps extends PropsWithChildren {
  className?: string;
  rows?: number;
}

export default function HomepageVaultsSlider({ className, children, rows = 2 }: HomepageVaultsSliderProps) {
  const sliderProps: Settings = {
    ...settings,
    rows,
  };

  return (
    <Slider className={className} {...sliderProps}>
      {children}
    </Slider>
  );
}
